import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useTranslation } from "react-i18next";

interface AsyncOperationProgressStepProps {
  currentItem: string;
  processedItems: number;
  totalItems: number;
  onCancel: () => void;
  processingTitleKey: string;
  processingDescriptionKey: string;
  processingCancelButtonKey: string;
  i18nMetadata?: Record<string, unknown>;
}

const FULL = 100;
const calculateProgress = (processedItems: number, totalItems: number) => {
  if (totalItems === 0) {
    return 0;
  }
  return Math.min((processedItems / totalItems) * FULL, FULL);
};

export const AsyncOperationProgressStep = ({
  currentItem,
  processedItems,
  totalItems,
  onCancel,
  processingTitleKey,
  processingDescriptionKey,
  processingCancelButtonKey,
  i18nMetadata,
}: AsyncOperationProgressStepProps) => {
  const { t } = useTranslation();

  return (
    <Card variant="ghost" className="p-0">
      <CardHeader className="p-0">
        <CardTitle>
          {t(processingTitleKey, {
            current: currentItem,
            ...i18nMetadata,
          })}
        </CardTitle>
      </CardHeader>
      <CardContent className="my-4 p-0">
        <p className="text-sm text-muted-foreground text-center mb-5">
          {t(processingDescriptionKey, {
            processed: processedItems,
            total: totalItems,
            ...i18nMetadata,
          })}
        </p>
        <Progress value={calculateProgress(processedItems, totalItems)} />
      </CardContent>
      <CardFooter className="flex justify-center p-0">
        <Button
          onClick={onCancel}
          variant="destructive"
          disabled={totalItems === 1}
        >
          {t(processingCancelButtonKey)}
        </Button>
      </CardFooter>
    </Card>
  );
};
